import * as React from "react";
import { Screen } from "./Screen";
import { TextField, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as language from "../languages/lang.json";
import axios from "axios";

const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    height: "100%"
  },
  error: {
    color: "red",
    textAlign: "center",
    paddingTop: "22px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  loginButton: {
    // color: "#fff",
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${darkHex(theme.palette.primary.dark, 0.5)} 100%)`,
    boxShadow: `0px 6px 12px rgba(0, 0, 0, 0.25), inset -2px 0px 0px ${theme.palette.primary.main}, inset 2px 0px 2px ${theme.palette.primary.main}`,
    borderRadius: 2
  }
});

const w: any = withStyles;

interface LoginProps {
  classes?: any;
  backgroundUrl: string;
  logoUrl: string;
  productName: string;
}

@w(styles)
export class Login extends React.Component<LoginProps> {
  state = {
    username: "",
    password: "",
    errorMsg: ""
  };

  handleChange = (key: string) => (event: any) => {
    this.setState({
      [key]: event.target.value
    });
  };

  checkForm = async (event: any, errorMsg: string) => {
    event.preventDefault();
    const { username, password } = this.state;
    const req = {
      method: "post",
      url: `${process.env.PUBLIC_URL}/login`,
      data: {
        username: username,
        password: password
      }
    };

    axios.request(req).then(
      (res) => {
        localStorage.setItem('i18nextLng', (localStorage["current-language-rim"] || "en"));
        window.location.href = res.data.path;
      },
      (error) => {
        this.setState({ errorMsg });
      }
    );
  };

  render() {
    const { classes, backgroundUrl, logoUrl, productName } = this.props;
    const { username, password } = this.state;
    const currentLanguage = localStorage["current-language-rim"] || "en";
    const t = language[currentLanguage];

    return (
      <Screen
        backgroundUrl={backgroundUrl}
        logoUrl={logoUrl}
        productName={productName}
        action={t["Login"]}
        form={
          <form className={classes.container}>
            <TextField
              inputProps={{ autoComplete: "true" }}
              label={t["Username"]}
              value={username}
              type="text"
              margin="normal"
              onChange={this.handleChange("username")}
            />

            <TextField
              inputProps={{ autoComplete: "true" }}
              label={t["Password"]}
              type="password"
              value={password}
              margin="normal"
              onChange={this.handleChange("password")}
            />

            <div className={classes.error} style={{ flex: 1 }}>
              {this.state.errorMsg && this.state.errorMsg}
            </div>

            <Button
              className={classes.loginButton}
              onClick={(event) => this.checkForm(event, t["Wrong username or password"])}
              type="submit"
            >
              {t["Login"]}
            </Button>
          </form>
        }
      />
    );
  }
}

function convertHex(hex: string, opacity: number) {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
}

function darkHex(hex: string, amount: number) {
  hex = hex.replace("#", "");
  const r = calculate(hex.substring(0, 2), amount);
  const g = calculate(hex.substring(2, 4), amount);
  const b = calculate(hex.substring(4, 6), amount);

  return `#${r}${g}${b}`;
}

function calculate(hex: string, amount: number) {
  let n = Math.round(parseInt(hex, 16) * amount).toString(16);

  if (n.length === 1) {
    n = `0${n}`;
  }

  return n;
}
